import {
  getHubSpotData,
  getSalesforceData,
  saveHubSpotData,
  saveSalesforceData,
  disconnectSalesforce,
  disconnectHubSpot,
  getDynamicsData,
  saveDynamicsData,
  disconnectDynamics,
} from 'services/api';
import Salesforce from './salesforce.png';
import HubSpot from './hubSpot.png';
import Dynamics from './dynamics.png';
import { crmTypes } from 'utils/helpers/crm';

export const getCrmDataUrl = crmType => {
  switch (crmType) {
    case crmTypes.SALESFORCE:
      return getSalesforceData;
    case crmTypes.HUBSPOT:
      return getHubSpotData;
    case crmTypes.DYNAMICS:
      return getDynamicsData;
    default:
      return '';
  }
};

export const getCrmSaveUrl = crmType => {
  switch (crmType) {
    case crmTypes.SALESFORCE:
      return saveSalesforceData;
    case crmTypes.HUBSPOT:
      return saveHubSpotData;
    case crmTypes.DYNAMICS:
      return saveDynamicsData;
    default:
      return '';
  }
};

export const getCrmDisconnectUrl = crmType => {
  switch (crmType) {
    case crmTypes.SALESFORCE:
      return disconnectSalesforce;
    case crmTypes.HUBSPOT:
      return disconnectHubSpot;
    case crmTypes.DYNAMICS:
      return disconnectDynamics;
    default:
      return '';
  }
};

export const getCrmImage = crmType => {
  switch (crmType) {
    case crmTypes.SALESFORCE:
      return Salesforce;
    case crmTypes.HUBSPOT:
      return HubSpot;
    case crmTypes.DYNAMICS:
      return Dynamics;
    default:
      return '';
  }
};

export const getCrmDescription = crmType => {
  switch (crmType) {
    case crmTypes.SALESFORCE:
      return 'Push contacts and account data directly into Salesforce with one click, keeping records accurate and allowing teams to continue their standard Salesforce workflows using SciLeads data.';
    case crmTypes.HUBSPOT:
      return 'Push contacts and account data directly into Hubspot with one click. Keeping records accurate and enables HubSpot workflows and sequences to run instantly from SciLeads data.';
    case crmTypes.DYNAMICS:
      return 'Push contacts and account data directly into Microsoft Dynamics with one click, keeping records accurate and allowing teams to continue their standard Dynamics workflows using SciLeads data';
    default:
      return '';
  }
};

export const getCrmLearnMoreUrl = () =>
  'https://portal.scileads.com/kb/new-article-85';
